import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const LoginPassword = () => {
    return (
        <div id="login-password">
            <div className="title-login xmb-5 xpx-2">
                <span>رمز عبور را وارد کنید</span>
            </div>
            <div className="description-login-page xmb-6 xpx-2">
                <span>رمز عبور حساب کاربری خود را وارد کنید</span>
            </div>
            <div className="input-log-in position-relative xmb-6 xmb-md-8">

            </div>
            <div className="input-log-in position-relative xmb-6">
                <input type="text" value="alisase@gmail.com" className="form-control input-normal"
                       disabled/>
                <div className="email-icon position-absolute">
                    <IconName name="email" className="icon"/>
                </div>
                <div className="change-code position-absolute"><span>ویرایش</span>
                </div>
            </div>
            <div className="position-relative xmb-6 xmb-md-8">
                <input type="password" placeholder="رمز عبور خود را وارد کنید"
                       className="form-control input-normal" id="input-password-login-page"/>
                <div className="password-icon position-absolute">
                    <IconName name="visibility" className="icon"/>
                </div>
                <div className="text-input position-absolute" id="reset-password-page"><span>بازیابی رمز عبور</span></div>
            </div>
            <div className="button-log-in xmb-6">
                <button type="submit">ورود</button>
            </div>
            <div className="phone-code-link xmb-2">
                <span id="go-code-page">ورود با رمز یک بار مصرف</span>
            </div>
        </div>
    );
};

export default LoginPassword;
